module.exports = __webpack_public_path__ + "static/media/poster_italy_pl.53c6bb3a.png";